module.exports = __webpack_public_path__ + "img/-h-绿色.f8625a3d.png";